module.exports = "<footer class=\"footer\">\r\n  <div class=\"container\">\r\n    <span>{{ 'APP_FOOTER' | translate }}</span>\r\n  </div>\r\n</footer>\r\n"